/** @jsx jsx */
import { useFormikContext } from 'formik'
import isEmpty from 'lodash.isempty'
import { useContext, useEffect, useState } from 'react'
import { Flex, jsx } from 'theme-ui'
import { QuestionStepContext } from '../../../context/QuestionStepContext'
import { getQuestionsBySectionId } from '../../../utils/strategyBuilder'
import LoadingSpinner from '../../common/LoadingSpinner'
import MarketingMatrixQuestion from './MarketingMatrixQuestion'

const MarketingMatrix = () => {
  const { values, setFieldValue } = useFormikContext()
  const { rawTemplate } = useContext(QuestionStepContext)
  const [isLoading, setIsLoading] = useState(true)
  const [questions, setQuestions] = useState()

  useEffect(() => {
    const questions = getQuestionsBySectionId({
      sectionId: '51',
      steps: 0,
      data: rawTemplate,
    })
    setQuestions(questions)
  }, [rawTemplate])

  useEffect(() => {
    if (!isEmpty(questions)) {
      setIsLoading(false)
    }
  }, [questions])

  if (isLoading) return <LoadingSpinner />

  return (
    <Flex
      sx={{
        flexDirection: 'column',
        paddingBottom: '60px',
      }}
    >
      {questions?.map(question => {
        return (
          <MarketingMatrixQuestion
            values={values}
            question={question}
            setFieldValue={setFieldValue}
            key={question.id}
          />
        )
      })}
    </Flex>
  )
}

MarketingMatrix.propTypes = {}

export default MarketingMatrix
